module.exports = __webpack_public_path__ + "static/media/icon-youtube.01f8ab28.svg";